import React, { useContext, useEffect, useRef, useState } from 'react';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import './Product.css';
import { site_url, site_url_img } from "./../config.js";
import { Formik } from 'formik';
import axios from 'axios';
import Swal from 'sweetalert2';
import { AuthContext } from './../AuthContext';
import { IndianCurrencyFormatter, FormatDate } from './../Function';

export default function Index() {
    const { user, refreshUser, vendordetails } = useContext(AuthContext);

    const [selectedImage, setSelectedImage] = useState(null);
    const [categorydata, setcategorydata] = useState([]);
    const [image, setImage] = useState(null);
    const [productdata, setproductlist] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const observerRef = useRef(null);
    const [editdetails, seteditdetails] = useState([]);

    
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);

            setSelectedImage(URL.createObjectURL(file));
        }
    };

    // useEffect(() => {
    //     const productcategory = async () => {
    //         try {

    //             const response = await axios.get(site_url + '/vendor/productcategory');

    //             if (response.data.status == 'success') {

    //                 setcategorydata(response.data.category);
    //             }
    //         } catch (error) {

    //         }
    //     }

    //     productcategory();
    // }, [])

    useEffect(() => {
        // reset and load when user available
        if (!user?.id) return;
        setproductlist([]);
        setCurrentPage(1);
        setHasMore(true);
        productlist(1, debouncedSearch, true);
    }, [user, debouncedSearch])

    useEffect(() => {
      
    }, [editdetails])
    const productlist = async (page = 1, q = '', isReset = false) => {
        if (isLoading || !hasMore) return;
        try {
            setIsLoading(true);
            const response = await axios.get(site_url + '/vendor/product_list/' + user.id, {
                params: { page, per_page: 20, search: q }
            });

            const items = response?.data?.product || [];
            const merged = isReset ? items : [...productdata, ...items];
            setproductlist(merged);

            // Determine if more pages exist
            const receivedCount = items.length;
            if (receivedCount < 20) {
                setHasMore(false);
            } else {
                setHasMore(true);
            }
        } catch (error) {
            setHasMore(false);
        } finally {
            setIsLoading(false);
        }
    }

    // Debounce search text
    useEffect(() => {
        const t = setTimeout(() => setDebouncedSearch(searchText.trim()), 400);
        return () => clearTimeout(t);
    }, [searchText]);

    // Infinite scroll using IntersectionObserver
    useEffect(() => {
        if (!observerRef.current) return;
        const el = observerRef.current;
        const observer = new IntersectionObserver((entries) => {
            const first = entries[0];
            if (first.isIntersecting && hasMore && !isLoading) {
                const nextPage = currentPage + 1;
                setCurrentPage(nextPage);
                productlist(nextPage, debouncedSearch, false);
            }
        }, { rootMargin: '200px' });

        observer.observe(el);
        return () => observer.disconnect();
    }, [currentPage, debouncedSearch, hasMore, isLoading, productdata.length]);
    const showSuccessAlert = () => {
        Swal.fire({
            title: 'Success!',
            text: 'Order placed successfully',
            icon: 'success',
            confirmButtonText: 'OK',
        });
    };
    const confirmButtonText = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
          }).then((result) => {
            if (result.isConfirmed) {
                deleteget(id);
              Swal.fire({
                title: "Deleted!",
                text: "Your file has been deleted.",
                icon: "success"
              });
            }
          });
    };
    const deleteget = async (id) => {
        try {

            const response = await axios.get(site_url + '/vendor/product_delete/'+id);

            if (response.data.status == 'success') {

                productlist();
            }
        } catch (error) {

        }
    }
    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const formData = new FormData();
            formData.append('pid', values.pid);
            if (values.product_price !== '') formData.append('product_price', values.product_price);
            if (values.selling_price !== '') formData.append('selling_price', values.selling_price);
            if (values.mrp_price !== '') formData.append('mrp_price', values.mrp_price);
            if (values.actual_price !== '') formData.append('actual_price', values.actual_price);
            if (values.owl_product_price !== '') formData.append('owl_product_price', values.owl_product_price);
            if (values.owl_sale_price !== '') formData.append('owl_sale_price', values.owl_sale_price);
            if (values.owl_mrp_price !== '') formData.append('owl_mrp_price', values.owl_mrp_price);
            if (values.owl_actual_price !== '') formData.append('owl_actual_price', values.owl_actual_price);

            const url = site_url + '/vendor/product_update';
            const response = await axios.post(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.data.status == 'success') {
                productlist();
                resetForm();
                showSuccessAlert();
            }
        } catch (error) {
            console.error(error);
        }
    };
    
    return (
        <div id="appCapsule">
            <h2 className='mt-3'>Product List</h2>
            <div className="form-group mt-2">
                <input
                    type="text"
                    placeholder="Search by product name"
                    value={searchText}
                    onChange={(e) => {
                        setSearchText(e.target.value);
                        setCurrentPage(1);
                        setHasMore(true);
                    }}
                />
            </div>
            {productdata.map((item) => (

                <div className="card mt-1"   >
                    <div className="p-2">
                        <div className='row'>
                            <div className='col-4'>
                                <img
                                    src={site_url_img + '/' + item.product_image}
                                    alt="img"
                                    className="image-block imaged w100"
                                />
                            </div>
                            <div className='col-8'>
                                <br></br>
                                <strong style={{ color: 'black' }}>{item.product_name}</strong><br></br>
                                <div className='mt-1' style={{ color: 'black' }}>
                                    {item.product_price !== undefined && <div><small>Product Price: <IndianCurrencyFormatter amount={item.product_price} /></small></div>}
                                    {item.selling_price !== undefined && <div><small>Selling Price: <IndianCurrencyFormatter amount={item.selling_price} /></small></div>}
                                    {item.mrp_price !== undefined && <div><small>MRP Price: <IndianCurrencyFormatter amount={item.mrp_price} /></small></div>}
                                    {item.actual_price !== undefined && <div><small>Actual Price: <IndianCurrencyFormatter amount={item.actual_price} /></small></div>}
                                    {item.owl_product_price !== undefined && <div><small>Owl Product Price: <IndianCurrencyFormatter amount={item.owl_product_price} /></small></div>}
                                    {item.owl_sale_price !== undefined && <div><small>Owl Sale Price: <IndianCurrencyFormatter amount={item.owl_sale_price} /></small></div>}
                                    {item.owl_mrp_price !== undefined && <div><small>Owl MRP Price: <IndianCurrencyFormatter amount={item.owl_mrp_price} /></small></div>}
                                    {item.owl_actual_price !== undefined && <div><small>Owl Actual Price: <IndianCurrencyFormatter amount={item.owl_actual_price} /></small></div>}
                                </div>
                                <div className='mt-2'>
                                    <button
                                        className="btn btn-sm btn-primary"
                                        data-bs-toggle="modal"
                                        data-bs-target="#withdrawActionSheeta"
                                        onClick={() => seteditdetails(item)}
                                    >
                                        Edit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}

            {/* Sentinel for infinite scroll */}
            <div ref={observerRef} style={{ height: 1 }} />
            {isLoading && (
                <div className="text-center p-2"><small>Loading...</small></div>
            )}







            <div
                className="modal fade action-sheet"
                id="withdrawActionSheet"
                tabIndex={-1}
                role="dialog"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">


                            <h5 className="modal-title">Product Details</h5>



                        </div>

                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <Formik
                                    initialValues={{formtype:'create', product_name: '', price: '', product_image: '', product_cate: '' ,pid:''}}
                                    validate={values => {
                                        const errors = {};

                                        if (!values.product_name) {
                                            errors.product_name = 'Product Name is required';
                                        }
                                        if (!values.price) {
                                            errors.price = 'Price is required';
                                        }


                                        return errors;
                                    }}
                                    onSubmit={handleSubmit}
                                >
                                    {({
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        handleBlur,
                                        handleSubmit,
                                        isSubmitting,
                                        /* and other goodies */
                                    }) => (
                                        <form onSubmit={handleSubmit}>
                                            <label><b>Product Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="product_price" onChange={handleChange} onBlur={handleBlur} value={values.product_price} placeholder="Product Price" />
                                            </div>
                                            <label><b>Selling Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="selling_price" onChange={handleChange} onBlur={handleBlur} value={values.selling_price} placeholder="Selling Price" />
                                            </div>
                                            <label><b>MRP Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="mrp_price" onChange={handleChange} onBlur={handleBlur} value={values.mrp_price} placeholder="MRP Price" />
                                            </div>
                                            <label><b>Actual Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="actual_price" onChange={handleChange} onBlur={handleBlur} value={values.actual_price} placeholder="Actual Price" />
                                            </div>
                                            <label><b>Owl Product Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="owl_product_price" onChange={handleChange} onBlur={handleBlur} value={values.owl_product_price} placeholder="Owl Product Price" />
                                            </div>
                                            <label><b>Owl Sale Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="owl_sale_price" onChange={handleChange} onBlur={handleBlur} value={values.owl_sale_price} placeholder="Owl Sale Price" />
                                            </div>
                                            <label><b>Owl MRP Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="owl_mrp_price" onChange={handleChange} onBlur={handleBlur} value={values.owl_mrp_price} placeholder="Owl MRP Price" />
                                            </div>
                                            <label><b>Owl Actual Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="owl_actual_price" onChange={handleChange} onBlur={handleBlur} value={values.owl_actual_price} placeholder="Owl Actual Price" />
                                            </div>
                                        </form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div
                className="modal fade action-sheet"
                id="withdrawActionSheeta"
                tabIndex={-1}
                role="dialog"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">


                            <h5 className="modal-title">Product Details Edit </h5>



                        </div>

                        <div className="modal-body">
                            <div className="action-sheet-content">
                                {(editdetails && 
                                <Formik
                                    initialValues={{
                                        pid: editdetails.pid,
                                        product_price: editdetails.product_price ?? '',
                                        selling_price: editdetails.selling_price ?? '',
                                        mrp_price: editdetails.mrp_price ?? '',
                                        actual_price: editdetails.actual_price ?? '',
                                        owl_product_price: editdetails.owl_product_price ?? '',
                                        owl_sale_price: editdetails.owl_sale_price ?? '',
                                        owl_mrp_price: editdetails.owl_mrp_price ?? '',
                                        owl_actual_price: editdetails.owl_actual_price ?? ''
                                    }}
                                    enableReinitialize={true}
                                    validate={() => ({})}
                                    onSubmit={handleSubmit}
                                >
                                    {({
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        handleBlur,
                                        handleSubmit,
                                        isSubmitting,
                                        /* and other goodies */
                                    }) => (
                                        <form onSubmit={handleSubmit}>
                                            <label><b>Product Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="product_price" onChange={handleChange} onBlur={handleBlur} value={values.product_price} placeholder="Product Price" />
                                            </div>
                                            <label><b>Selling Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="selling_price" onChange={handleChange} onBlur={handleBlur} value={values.selling_price} placeholder="Selling Price" />
                                            </div>
                                            <label><b>MRP Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="mrp_price" onChange={handleChange} onBlur={handleBlur} value={values.mrp_price} placeholder="MRP Price" />
                                            </div>
                                            <label><b>Actual Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="actual_price" onChange={handleChange} onBlur={handleBlur} value={values.actual_price} placeholder="Actual Price" />
                                            </div>
                                            <label><b>Owl Product Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="owl_product_price" onChange={handleChange} onBlur={handleBlur} value={values.owl_product_price} placeholder="Owl Product Price" />
                                            </div>
                                            <label><b>Owl Sale Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="owl_sale_price" onChange={handleChange} onBlur={handleBlur} value={values.owl_sale_price} placeholder="Owl Sale Price" />
                                            </div>
                                            <label><b>Owl MRP Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="owl_mrp_price" onChange={handleChange} onBlur={handleBlur} value={values.owl_mrp_price} placeholder="Owl MRP Price" />
                                            </div>
                                            <label><b>Owl Actual Price</b></label>
                                            <div className="form-group">
                                                <input type="number" name="owl_actual_price" onChange={handleChange} onBlur={handleBlur} value={values.owl_actual_price} placeholder="Owl Actual Price" />
                                            </div>
                                            <div className="form-group basic">
                                            <a onClick={()=>confirmButtonText(editdetails.pid)}
                                                    type="button" 
                                                    className="btn btn-danger btn-block btn-lg"
                                               
                                                >
                                                 Delete
                                                </a>
                                                <button
                                                    type="submit" disabled={isSubmitting}
                                                    className="btn btn-primary btn-block btn-lg"
                                                >
                                                    Update Prices
                                                </button>
                                            </div>
                                        </form>
                                    )}
                                </Formik>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
            <Sidebar />

        </div>
    )

}
